import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * возращает выбранный блок.
 * ! можно использовать только в внутри LongreadBlockSettings
 *
 * @returns {*}
 */
export const useActiveBlock = () => {
    const store = useStore();

    return computed(() => store.getters['longread/activeBlock']);
};
